import { NgModule } from '@angular/core';
import { CommentsBootstrapModule } from './comments-bootstrap.module';
import { CommentsRoutingModule } from './comments-routing.module';
import { DatatablesModule, FormsModule, SupportModule } from '@kaiser-software/chassis-core';
import { Pages } from './pages';
import { Modals } from './modals';
import { Plugins } from './plugins';
import { Components } from './components';
import { Services } from './services';

@NgModule({
    imports: [FormsModule, DatatablesModule, SupportModule, CommentsBootstrapModule, CommentsRoutingModule],
    declarations: [Pages, Modals, Plugins, Components],
    entryComponents: [Pages, Modals, Plugins, Components],
    providers: [Services],
    exports: [Modals, Plugins]
})
export class ChassisCommentsModule {

    constructor() {
        console.log('Chassis Comments Module bootstrapped.');
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-comments/src/app/comments.module.ts